import { set as setCookie, get as getCookie } from 'store/actions/cookies';
import uuid from 'uuid/v4';
import sendMockResponse from './sendMockResponse';
import { SID_COOKIE_NAME } from '../../../constants/cookies';

const THIRTY_MINS_IN_MS = 1200000;

const getSessionId = () =>
  function* () {
    let currSid = yield getCookie(SID_COOKIE_NAME);

    if (!currSid) {
      currSid = uuid();
    }

    yield setCookie(SID_COOKIE_NAME, currSid, THIRTY_MINS_IN_MS, {
      expiresInDays: false,
    });

    return currSid;
  };

const sendRequest = (request) =>
  function* () {
    const { headers = {}, getMock, mockParams, withSessionId } = request;

    let { body = {} } = request;

    const mockResponse = getMock && getMock(mockParams || {});

    if (mockResponse) {
      return yield sendMockResponse(mockResponse);
    }

    if (withSessionId) {
      const sessionId = yield getSessionId();

      body = { ...body, sessionId };
    }

    return yield {
      request: { ...request, body, headers },
    };
  };

export default (getRequest) =>
  (...args) =>
    function* () {
      const request = getRequest(...args);

      return yield sendRequest(request);
    };
